import {
  DOCUMENT_CATEGORY_OPTIONS,
  MEMBER_OPTIONS,
  PATIENT_OPTIONS,
  TAG_DOCUMENT_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

const allowed_operators = ['is', 'is not', 'is any of'];

export default function getDocumentFilters({ level, options, myPortalPractice }) {
  const types = [
    { value: 'image', label: 'Image' },
    { value: 'pdf', label: 'PDF' }
  ];

  return {
    name: {
      title: 'Document Name',
      placeholder: 'Search by document name',
      icon: 'editor-text-mono',
      allowed_operators: ['contains', 'does not contain']
    },
    ...(level === 'practice'
      ? {
          patient_id: { ...PATIENT_OPTIONS, allowed_operators }
        }
      : {}),
    ...(level === 'practice'
      ? {
          type: {
            title: 'Type',
            icon: 'list-unordered-mono',
            queryFn: (_, data) => {
              const searchTerm = data.filters.searchTerm || '';
              return {
                options: types.filter((status) =>
                  status.label.toLowerCase().includes(searchTerm.toLowerCase())
                )
              };
            },
            allowed_operators,
            queryKey: 'document_types.options'
          }
        }
      : {}),
    category: {
      ...DOCUMENT_CATEGORY_OPTIONS,
      ...(myPortalPractice && { params: { practiceId: myPortalPractice } })
    },
    ...(level === 'practice'
      ? {
          uploaded_by_patient: {
            ...PATIENT_OPTIONS,
            title: 'Uploaded By Patient',
            allowed_operators
          }
        }
      : {}),

    uploaded_by: {
      ...MEMBER_OPTIONS,
      ...(myPortalPractice && { params: { practiceId: myPortalPractice } }),
      icon: 'user-2-mono',
      title: level === 'practice' ? 'Uploaded By Staff' : 'Uploaded By',
      allowed_operators
    },
    date: {
      type: 'date-range',
      title: 'Created At',
      placeholder: 'Select start and end date',
      icon: 'calendar-mono'
    },
    ...(options?.enableTags
      ? {
          tags: { ...TAG_DOCUMENT_OPTIONS, allowed_operators }
        }
      : {})
  };
}
